import React from 'react';
import { Column } from 'material-table';

/* eslint-disable no-useless-escape */
export function validateEmail(email: string): boolean {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
export function validatePassword(password: string): boolean {
    const re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~@#$%^&*+=`|{}:;!.?\"()\[\]-])[\w~@#$%^&*+=`|{}:;!.?\"()\[\]-]{12,64}$/;
    
    if (!re.test(password)) {
        return false;
    }

    return calculateEntropy(password) >= 60;
}

function calculateEntropy(password: string): number {
    let charsetSize = 0;

    if (/[a-z]/.test(password)) charsetSize += 26;
    if (/[A-Z]/.test(password)) charsetSize += 26; 
    if (/\d/.test(password)) charsetSize += 10;
    if (/[~@#$%^&*+=`|{}:;!.?"()\[\]-]/.test(password)) charsetSize += 20;

    return password.length * Math.log2(charsetSize);
}

export function validateSpecialCharacter(value: string): boolean {
    const re = /[*|\":;<>[\]{}\\()'@#$%&+=!?]/;
    return re.test(String(value).toLowerCase());
}

export function validateSpecialCharacterVehicle(value: string): boolean {
    const re = /[*|\":;<>{}\\()'@#$%&+=!?]/;
    return re.test(String(value).toLowerCase());
}

export function validNumber(value: string): boolean {
    const re = /^[0-9]*$/;
    return re.test(String(value).toLowerCase()); 
}

export function validNumberList(value: string): boolean {
    const re = /^[0-9]*(\;?[0-9]*)*$/;
    return re.test(String(value).toLowerCase()); 
}

export function getDateTime(dateAsString: Date | null) : string {
    if (dateAsString) {
        const date = new Date(dateAsString);

        return new Intl.DateTimeFormat('default', {
            hour: 'numeric', minute: 'numeric', second: 'numeric'
        }).format(date);
    }

    return '00:00:00';
}

export function getTableColumn(
    title: string,
    field: string,
    type: 'string' | 'boolean' | 'numeric' | 'date' | 'datetime' | 'time' | 'currency' | undefined,
    align: 'center' | 'inherit' | 'justify' | 'left' | 'right' | undefined,
    cellStyle?: React.CSSProperties | undefined,
    defaultSort?: 'asc' | 'desc' | undefined,
    sorting?: boolean,
    filtering?: boolean): Column<any> {
    const column: Column<any> = 
    {
        title: title,
        field: field,
        type: type,
        align: align,
        cellStyle: cellStyle,
        defaultSort: defaultSort,
        sorting: sorting,
        filtering: filtering
    };    

    return column;
}

export function timeToNumber(date: Date) : number {
    return (date.getHours()*60*60 + date.getMinutes()*60 + date.getSeconds());
}

export function numberToTime(value: number) : Date {
    const date = new Date();

    date.setHours(value/(60*60));
    date.setMinutes((value%(60*60))/60);
    date.setSeconds((value%(60*60))%60);

    return date;
}


export function stringToTime(string: string | undefined) : Date {
    const date = new Date();

    if(string) {
        date.setHours(parseInt(string.split(':')[0]));
        date.setMinutes(parseInt(string.split(':')[1]));
        date.setSeconds(parseInt(string.split(':')[2]));
    }

    return date;
}

export function numberFormat(value: string): number {
    const number = value.toString().split('.');

    if(number.length > 1) { 
        if(number[1].length > 3)
            return parseFloat(`${number[0]}.${number[1].toString().substring(0,3)}`);
    }

    return parseFloat(value);
}

export function handleDisplayDate(value: Date | string, separator = '-'): string {
    const date = new Date(value);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();

    return (dd + separator + mm + separator + yyyy);
}